import { Link } from 'react-router-dom';

import { isPalmettoFinanceUser } from '../../auth/RequirePalmettoFinanceUser';
import MoveStrandedAssetAction from '../components/MoveStrandedAssetAction';

import { useAccountDetailsContext } from './AccountDetailsContext';

export function usePartnerOrgProperties() {
  const { account, claims, isLightReachAdmin } = useAccountDetailsContext();

  return {
    heading: 'Partner Org',
    values: [
      ...(isPalmettoFinanceUser(claims)
        ? [
            {
              label: 'Name',
              value: (
                <Link to={`${location.origin}/settings/organizations/${account?.organizationId}`}>
                  {account?.organizationId?.toUpperCase()}
                </Link>
              ),
            },
            {
              label: 'Licensed Partner Org',
              value: (
                <Link to={`${location.origin}/settings/organizations/${account?.licensedOrganizationId}`}>
                  {account?.licensedOrganizationId?.toUpperCase()}
                </Link>
              ),
            },
          ]
        : [
            { label: 'Name', value: account?.organizationId?.toUpperCase() },
            { label: 'Licensed Partner Org', value: account?.licensedOrganizationId?.toUpperCase() || '' },
          ]),
      ...(isLightReachAdmin
        ? [
            {
              label: '',
              value: <MoveStrandedAssetAction />,
            },
          ]
        : []),
    ],
  };
}
